import { app, scriptService } from "../../feathers";
// import { EventBus } from "../../eventBus";
import router from "../../routes.js";
// import runHook from "Js/hookHandler";
import { actions } from "../../actionsProcessor";
const getQueryParams = require("Js/bfUtilities").getQueryParams;
// import _ from "lodash";
import store from 'Js/store'

export default {
  state: {
    actions: [],
    token: null,
    authenticated: false,
    isAuthenticating: false,
    profile: null,
    email: null
  },

  actions: {
    CHECK_AUTH: ({ commit, state }, noRedirect) => {
      if (!store.getters.isOnline()) return;
      return new Promise((resolve, reject) => {
        app
          .reAuthenticate()
          .then(result => {
            commit("LOGIN_SUCCESS", result);
            if (state.user) {
              resolve();
            }
            resolve();
            // TODO update user if not set
          })
          .catch(() => {
            if (noRedirect) {
              resolve();
            } else {
              commit("LOGIN_FAILURE");
              reject();
            }
          });
      });
    },

    NO_AUTH: ({ commit, state }) => {
      return new Promise((resolve, reject) => {
        resolve();
        // TODO update user if not set
      });
    },

    GET_USER: ({ commit }) => {
      // fetches and udpates store/auth/user from JWT userid

      if (!state.user) {
        return;
      }

      return new Promise((resolve, reject) => {
        app.reAuthenticate()
          .then(JWTpayload => {
            let user = JWTpayload.user.id;
            return user;
          })
          .then(user => {
            app.set("user", user);
            commit("SET_USER", user);
            return Promise.resolve();
          })
          .catch(error => {
            console.log("error @ GET_USER: ", error);
            reject();
          });
      });
    },

    ONLOGINHOOK: ({ commit }, {action}) => {
      return new Promise((resolve, reject) => {
        app
          .reAuthenticate()
          .then(JWTpayload => {
            //app.authentication.authenticated
            return scriptService.create({
              service: "user.onLogin",
              data: {
                query: getQueryParams()
              }
            });
          })
          .then(data => {
            // update the store with user
            let hasPath = _.filter(data.actions, { action: "path" }).length;

            commit('SET_APP', data.app );
            delete data.app;

            if (data.actions && data.actions.length) {
              actions.queue({actions: data.actions, idThread: action.idThread, insert: true});
            }
            else {
              actions.process(action);
            }

            if (hasPath) {
              return; // actions take priority
            } else if (getQueryParams().redirect) {
              router.push(getQueryParams().redirect); // do redirect
            } else {
              router.push("/");
            }
          })

          .catch(error => {
            console.log("error @ONLOGINHOOK: ", error);
            reject(error);
          });
      });
    },

    ONREGISTERHOOK: ({ commit }, {payload, action}) => {
      let params = {
        service: "user.onRegistration",
        data: payload
      };
      params.data.query = getQueryParams();
      let theParams = Object.assign({}, params); // test to strip out

      return new Promise((resolve, reject) => {
        scriptService
          .create(theParams)
          .then(data => {
            if (data.actions) {
              actions.queue({actions: data.actions, idThread: action.idThread, insert: true});
            } else {
              actions.process(action);
              router.push("/dash"); // default to home page
            }
            resolve(data);
          })
          .catch(error => {
            console.log("error @ONREGISTERHOOK: ", error);
            reject();
          });
      });
    },

    ONPWRESETHOOK: ({ commit }, {email, action}) => {
      return new Promise((resolve, reject) => {
        app
          .service("authManagement")
          .create({
            action: "sendResetPwd",
            value: {
              email
            }
          })
          .then(data => {
            // update the store with hook results
            actions.queue({actions: data.actions, idThread: action.idThread, insert: true});
            resolve(data);
          })
          .catch(error => {
            console.log("error @ONPWRESETHOOK: ", error.message);
            reject(error);
          });
      });
    },

    RESETPW: ({ commit }, params) => {
      return new Promise((resolve, reject) => {
        app
          .service("authManagement")
          .create({
            action: "resetPwdLong",
            value: {
              token: params.token,
              password: params.password
            }
          })
          .then(data => {
            // update the store with hook results
            actions.queue({actions: data.actions, idThread: params.action.idThread, insert: true});
            resolve(data);
          })
          .catch(error => {
            console.log("error @RESETPW: ", error.message);
            reject(error);
          });
      });
    },

    VERIFYSIGNUP: ({ commit }, params) => {
      return new Promise((resolve, reject) => {
        app
          .service("authManagement")
          .create({
            action: "verifySignupLong",
            value: params.token
          })
          .then(data => {
            // update the store with hook results
            // console.log("@VERIFYSIGNUP Then", data);
            actions.queue({actions: data.actions, idThread: params.action.idThread, insert: true});
            resolve(data);
          })
          .catch(error => {
            console.log("error @VERIFYSIGNUP: ", error.message);
            reject(error);
          });
      });
    },

    RESENDVERIFYSIGNUP: ({ commit }, {email, action}) => {
      return new Promise((resolve, reject) => {
        app
          .service("authManagement")
          .create({
            action: "resendVerifySignup",
            value: {
              email
            }
          })
          .then(data => {
            // update the store with hook results
            // console.log("@RESENDVERIFYSIGNUP Then", data);
            actions.queue({actions: data.actions, idThread: action.idThread, insert: true});
            resolve(data);
          })
          .catch(error => {
            console.log("error @RESENDVERIFYSIGNUP: ", error.message);
            reject(error);
          });
      });
    },

    SIGNUP: ({ commit }, { name, email, password }) => {
      return new Promise((resolve, reject) => {
        app
          .service("/users")
          .create({
            name,
            email,
            password
          })
          .then(result => {
            resolve(result);
          })
          .catch(error => {
            error.code == 400 ? error.message = 'This email has already been registered.': error.message;
            reject(error);
          });
      });
    },

    LOGIN: ({ commit, state, rootState, dispatch }, { email, password }) => {
      return new Promise((resolve, reject) => {
        app
          .authenticate({
            strategy: "local",
            email: email,
            password: password
          })

          .then(result => {
            commit("LOGIN_SUCCESS", result);
            rootState.site, "content.namedActions.onLogin" ? dispatch('ACTIONS_QUEUE', rootState.site.content.namedActions.onLogin): null;
            //Adding result to resolve
            resolve(result);
            
          })
          .catch(error => {
            commit("LOGIN_FAILURE");
            // Feathers authentication-client only auto-resets on 401/403. A FileMaker
            // missing-user login returns 404 and leaves a rejected auth promise cached,
            // which poisons later service calls (utility hooks, form loads). Always clear.
            try {
              if (app.authentication && typeof app.authentication.reset === 'function') {
                app.authentication.reset();
              } else if (typeof app.set === 'function') {
                app.set('authentication', null);
              }
            } catch (_) { /* best-effort cache clear */ }
            reject(error);
          });
      });
    },

    LOGOUT: ({ commit }, params) => {
      return new Promise((resolve, reject) => {
        app
          .logout()
          .then(result => {
            actions.process((params && params.action) || null)
            commit("LOGOUT");
            resolve();
          })
          .catch(error => {
            console.log("@auth.catch error", error);
            commit("LOGIN_FAILURE");
            reject(error);
          });
      });
    }
  },

  mutations: {
    LOGIN_REQUEST: state => {
      state.isAuthenticating = true;
    },

    LOGIN_FAILURE: state => {
      state.isAuthenticating = false;
    },

    LOGIN_SUCCESS: (state, result) => {
      state.token = result.accessToken;
      state.isAuthenticating = false;
      state.authenticated = true;
    },

    SET_USER: (state, result) => {
      console.log('@store auth SET_USER result: ', result)
      state.user = result;
    },

    LOGOUT: state => {
      state.token = null;
      state.user = null;
      state.authenticated = false;
      state.profile = null;
    }
  },

  getters: {
    isAuthenticated: (state, getters, rootState, rootGetters) => name => {
      return state.authenticated;
    }
  }
};
